import { motion } from "framer-motion";
import { Link } from "wouter";
import ResponsiveImage from "@/components/ui/responsive-image";

export default function Hero() {
  const scrollToWaitlist = () => {
    document.getElementById('waitlist')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-[90vh] bg-[#FF7063] pt-16">
      <div className="container max-w-6xl mx-auto px-4 h-full flex flex-col justify-between py-8">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-left order-2 md:order-1"
          >
            <h1 className="text-5xl sm:text-6xl md:text-7xl font-bold text-white mb-6 flex flex-col">
              <span>BUDGETING</span>
              <span>IS BROKEN</span>
            </h1>
            <p className="text-xl text-white mb-8 max-w-2xl">
              Because it never fixed the real problem—your relationship with money.
            </p>
            <div className="flex flex-wrap items-center gap-4">
              <button
                onClick={scrollToWaitlist}
                className="px-6 py-3 bg-[#F5E6D3] text-[#FF7063] rounded-lg hover:bg-opacity-90 transition-colors font-medium"
              >
                Join Waitlist
              </button>
              
              <a 
                href="https://chromewebstore.google.com/detail/impause/deofpffeelbbckhopgmkgapcogaicahn" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:opacity-90 transition-opacity"
              >
                <picture>
                  <source 
                    srcSet="/images/optimized/Chrome_Web_store-320.webp" 
                    type="image/webp" 
                  />
                  <img 
                    src="/images/Chrome_Web_store.png" 
                    alt="Available in the Chrome Web Store" 
                    className="h-12 w-auto"
                    width={180} 
                    height={48}
                    loading="eager"
                  />
                </picture>
              </a>
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="order-1 md:order-2 flex justify-end"
          >
            <div className="w-full max-w-md relative">
              <picture>
                {/* Primary WebP source with specific dimensions */}
                <source 
                  srcSet="/images/optimized/Impause-app-(Copy)-(2)-640.webp 640w, /images/optimized/Impause-app-(Copy)-(2)-320.webp 320w" 
                  type="image/webp"
                  sizes="(max-width: 640px) 300px, 600px"
                />
                {/* PNG fallback */}
                <source 
                  srcSet="/images/optimized/Impause-app-(Copy)-(2)-640.png 640w, /images/optimized/Impause-app-(Copy)-(2)-320.png 320w" 
                  type="image/png"
                  sizes="(max-width: 640px) 300px, 600px"
                />
                {/* Base image */}
                <img
                  src="/images/optimized/Impause-app-(Copy)-(2)-640.webp"
                  alt="Impause App Interface"
                  className="w-full h-auto"
                  width={600}
                  height={800}
                  loading="eager"
                />
              </picture>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}